import { render, staticRenderFns } from "./FatorAtuacao.vue?vue&type=template&id=067a85d2"
import script from "./FatorAtuacao.vue?vue&type=script&lang=js"
export * from "./FatorAtuacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports